import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";
var _class, _class2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import BaseAdapter from '../base/BaseAdapter';
import { getUrlParams, getShareMessage, urlFormatter, isZZ, isUpDoor, isZLJ, isAndroid, getPoiMarkerUrl, domainReplacement, isZZUrl, isZZSellerUrl, isCheckUrl, isZLJUrl, addQuery, addMetricToObj, getPPU, getCookie, getStrCookie, compareVersion, setCookie, formartChooseAddressRes, isHTTPUrl, getZZVersion, logWarn, guid, loadJS, checkSdkSupport, isFunction } from '../../core/utils';
import { beforeLogin } from '../base/LoginAdapter';
var ZZAdapter = (_class = (_class2 = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(ZZAdapter, _BaseAdapter);
  var _super = _createSuper(ZZAdapter);
  function ZZAdapter(_native) {
    var _this;
    _classCallCheck(this, ZZAdapter);
    return _this = _super.call(this, _native, 'https://s1.zhuanstatic.com/common/zzapp/static/js/1.30.15/index.js', function () {
      _this.ZZAPP = window.ZZAPP = window['@zz-common/zz-jssdk']["default"];
      _this.__sdk = _this.ZZAPP;
    });
  }
  _createClass(ZZAdapter, [{
    key: "share",
    value: function share(shareMessage, callback) {
      if (isZLJ) {
        return logWarn('share: 找靓机app不支持 setRightShareBtn 给原生导航栏设置分享');
      }
      this.ZZAPP.setRightShareBtn(_objectSpread(_objectSpread({}, getShareMessage(shareMessage)), {}, {
        needSuccessToast: '1'
      }), callback);
    }
  }, {
    key: "shareDetail",
    value: function shareDetail(obj, callback) {
      var defaultPicPath = 'https://pic2.zhuanstatic.com/bidding/big/n_v1bkujjd2nmb7fmlmfhq4a_5ea9d0b68923e35c.png?w=640&h=480';
      var url = obj.url,
        picPaths = obj.picPaths;
      url = urlFormatter(url);
      picPaths = picPaths || defaultPicPath;
      this.ZZAPP.setShareData(_objectSpread(_objectSpread({}, obj), {}, {
        url: url,
        picPaths: picPaths
      }), callback);
    }
  }, {
    key: "shareClick",
    value: function shareClick(shareMessage, callback) {
      if (isZLJ) {
        this.ZZAPP.openShare(_objectSpread(_objectSpread({}, getShareMessage(shareMessage)), {}, {
          type: (shareMessage === null || shareMessage === void 0 ? void 0 : shareMessage.type) || 6,
          success: function success(data) {
            callback && callback(_objectSpread({
              code: '0'
            }, data));
          },
          fail: function fail(data) {
            callback && callback(_objectSpread({
              code: '-200'
            }, data));
          }
        }));
      } else {
        this.ZZAPP.setSharePanel(getShareMessage(shareMessage), callback);
      }
    }
  }, {
    key: "shareToAssignPlatform",
    value: function shareToAssignPlatform(shareMessage, callback) {
      this.ZZAPP.shareToPlatform(getShareMessage(shareMessage), callback);
    }
  }, {
    key: "enterHome",
    value: function enterHome() {
      if (isZLJ) {
        this.skipToUrl({
          targetUrl: 'zljgo://native_api?type=132'
        });
      } else {
        this.skipToUrl({
          targetUrl: 'zhuanzhuan://jump/core/mainPage/jump?tabId=0'
        });
      }
    }
  }, {
    key: "setRightBtn",
    value: function setRightBtn(obj, callback) {
      var self = this;
      obj.url = domainReplacement(obj.url);
      if (isZLJ) {
        this.ZZAPP.changeRightButton({
          title: obj.label,
          icon: obj.icon,
          action: function action() {
            self.skipToUrl({
              targetUrl: obj.url
            });
          }
        });
      } else {
        this.ZZAPP.setRightBtn(obj, callback);
      }
    }
  }, {
    key: "getMapLocation",
    value: function getMapLocation() {
      var _this2 = this;
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        hideToast: false
      };
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      // 兼容旧版 只传入callback
      if (typeof obj === 'function') {
        callback = obj;
      }
      var v = getCookie('v');
      if (!obj.ignoreApp && isZZ && compareVersion(v, '6.4') > 0) {
        var cb = function cb(res) {
          var _ref = res.villageInfo || {},
            lat = _ref.lat,
            lng = _ref.lng,
            address = _ref.address,
            villageName = _ref.villageName,
            businessName = _ref.businessName;
          var o = {
            module: 'locationPicker',
            latlng: {
              lat: lat,
              lng: lng
            },
            poiaddress: address,
            poiname: villageName,
            cityname: businessName
          };
          typeof callback === 'function' && callback(o);
        };
        this.ZZAPP.getCoordinate(function (res) {
          var lon = res === null || res === void 0 ? void 0 : res.lon;
          var lat = res === null || res === void 0 ? void 0 : res.lat;

          // 因为getCoordinate只能获取到缓存的经纬度，如果之前没有授权。到页面里面会在授权
          // if (!obj?.hideToast && parseFloat(lon) === 0 && parseFloat(lat) === 0) {
          //   this.ZZAPP.toast({
          //     msg: '抱歉，当前无法获取地理位置，请设置允许转转使用定位功能',
          //   })
          //   return
          // }

          _this2.ZZAPP.getMapLocation({
            lon: lon,
            lat: lat
          }, cb);
        });
      } else {
        _get(_getPrototypeOf(ZZAdapter.prototype), "getMapLocation", this).call(this, obj, callback);
      }
    }
  }, {
    key: "skipToDetail",
    value: function skipToDetail(obj, callback) {
      var _this3 = this;
      if (isZLJ) {
        _get(_getPrototypeOf(ZZAdapter.prototype), "skipToDetail", this).call(this, obj);
      } else {
        // 转转端内 支持 extraParam 自定义扩展参数，拼接到商品详情页 url query，
        // 但是，需要联系 平台RD或者客户端同学 配置指定 query 参数。
        var zzInfoId = obj.zzInfoId,
          infoId = obj.infoId,
          metric = obj.metric,
          from = obj.from,
          _obj$extraParam = obj.extraParam,
          extraParam = _obj$extraParam === void 0 ? {} : _obj$extraParam;
        zzInfoId && (infoId = zzInfoId);
        this.agentSkipToDetail(obj, function () {
          if (from == '13') {
            var extParam = '';
            try {
              extParam = encodeURIComponent(JSON.stringify(extraParam));
            } catch (error) {
              console.error('[adapter - skipToDetail] extraParam 参数解析异常');
            }
            _this3.enterUnifiedUrl({
              unifiedUrl: "zhuanzhuan://jump/core/infoDetail/jump?" + "infoId=".concat(infoId) + "&FROM=".concat(from) + "&metric=".concat(metric) + "&extraParam=".concat(extParam)
            });
          } else {
            var _extParam = '';
            try {
              _extParam = JSON.stringify(extraParam);
            } catch (error) {
              console.error('[adapter - skipToDetail] extraParam 参数解析异常');
            }
            _this3.ZZAPP.enterDetail(_objectSpread(_objectSpread({}, obj), {}, {
              zzInfoId: zzInfoId,
              infoId: infoId,
              metric: metric,
              extraParam: _extParam
            }), callback);
          }
        });
      }
    }
  }, {
    key: "skipToUrl",
    value: function () {
      var _skipToUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(obj, callback) {
        var _this$native, _this$native$currentP;
        var targetUrl, _obj$extra, extra, _obj$needNewWindow, needNewWindow;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                targetUrl = obj.targetUrl, _obj$extra = obj.extra, extra = _obj$extra === void 0 ? {} : _obj$extra, _obj$needNewWindow = obj.needNewWindow, needNewWindow = _obj$needNewWindow === void 0 ? true : _obj$needNewWindow;
                targetUrl = urlFormatter(targetUrl);
                targetUrl = addQuery(targetUrl, extra);
                targetUrl = domainReplacement(targetUrl);

                // 兼容大师熊
                // console.log('currentPlatform-name', this.native?.currentPlatform?.name)
                if (!(((_this$native = this["native"]) === null || _this$native === void 0 ? void 0 : (_this$native$currentP = _this$native.currentPlatform) === null || _this$native$currentP === void 0 ? void 0 : _this$native$currentP.name) === 'zzqcidentity')) {
                  _context.next = 7;
                  break;
                }
                this.ZZAPP.navigateForward(_objectSpread(_objectSpread({}, obj), {}, {
                  toPageUrl: targetUrl
                }), isFunction(callback) ? callback : function () {});
                return _context.abrupt("return");
              case 7:
                if (!(isZZUrl(targetUrl) || isZZSellerUrl(targetUrl) || isCheckUrl(targetUrl))) {
                  _context.next = 19;
                  break;
                }
                _context.prev = 8;
                if (!checkSdkSupport('10.0.0')) {
                  _context.next = 12;
                  break;
                }
                this.ZZAPP.navigateForward(_objectSpread(_objectSpread({}, obj), {}, {
                  toPageUrl: targetUrl
                }), isFunction(callback) ? callback : function () {});
                return _context.abrupt("return");
              case 12:
                _context.next = 18;
                break;
              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](8);
                this.ZZAPP.enterPage(_objectSpread(_objectSpread({}, obj), {}, {
                  targetUrl: targetUrl
                }), callback);
                return _context.abrupt("return");
              case 18:
                return _context.abrupt("return", this.enterUnifiedUrl(_objectSpread(_objectSpread({}, obj), {}, {
                  unifiedUrl: targetUrl
                }), callback));
              case 19:
                if (!needNewWindow) {
                  _context.next = 39;
                  break;
                }
                if (isZLJ) {
                  this.skipToUrlZLJ(_objectSpread(_objectSpread({}, obj), {}, {
                    targetUrl: targetUrl
                  }));
                }
                if (!isUpDoor) {
                  _context.next = 25;
                  break;
                }
                // 兼容上门超人
                // https://fe.zhuanspirit.com/common/jsSdkDoc/sdk/doc.html#navigatebackward
                this.ZZAPP.navigateForward(_objectSpread(_objectSpread({}, obj), {}, {
                  toPageUrl: targetUrl
                }), callback);
                _context.next = 37;
                break;
              case 25:
                _context.prev = 25;
                if (!checkSdkSupport('10.0.0')) {
                  _context.next = 29;
                  break;
                }
                this.ZZAPP.navigateForward(_objectSpread(_objectSpread({}, obj), {}, {
                  toPageUrl: targetUrl
                }), isFunction(callback) ? callback : function () {});
                return _context.abrupt("return");
              case 29:
                _context.next = 36;
                break;
              case 31:
                _context.prev = 31;
                _context.t1 = _context["catch"](25);
                console.log('skipToUrl2', _context.t1);
                this.ZZAPP.enterPage(_objectSpread(_objectSpread({}, obj), {}, {
                  targetUrl: targetUrl
                }), callback);
                return _context.abrupt("return");
              case 36:
                this.ZZAPP.enterPage(_objectSpread(_objectSpread({}, obj), {}, {
                  targetUrl: targetUrl
                }), callback);
              case 37:
                _context.next = 40;
                break;
              case 39:
                _get(_getPrototypeOf(ZZAdapter.prototype), "skipToUrl", this).call(this, obj);
              case 40:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 14], [25, 31]]);
      }));
      function skipToUrl(_x, _x2) {
        return _skipToUrl.apply(this, arguments);
      }
      return skipToUrl;
    }()
  }, {
    key: "skipToUrlZLJ",
    value: function skipToUrlZLJ(obj) {
      var targetUrl = obj.targetUrl,
        _obj$needClose = obj.needClose,
        needClose = _obj$needClose === void 0 ? 0 : _obj$needClose;
      targetUrl = urlFormatter(targetUrl);
      if (isZLJUrl(targetUrl)) {
        location.href = targetUrl;
      } else {
        var closebefore = 0;
        if (needClose == 1) {
          closebefore = 1;
          targetUrl = addQuery(targetUrl, {
            closebefore: 1
          });
          if (isAndroid()) {
            this.ZZAPP.enterUnifiedUrl({
              unifiedUrl: "zljgo://native_api?type=1&closebefore=".concat(closebefore, "&content=").concat(encodeURIComponent(targetUrl))
            }, function () {});
            return;
          }
        }
        location.href = "zljgo://native_api?type=1&closebefore=".concat(closebefore, "&content=").concat(encodeURIComponent(targetUrl));
      }
    }
  }, {
    key: "skipToOrder",
    value: function skipToOrder(obj, callback) {
      var newObj = addMetricToObj(obj);
      this.ZZAPP.enterConfirmOrder(newObj, callback);
    }
  }, {
    key: "login",
    value: function login(callback) {
      var _this4 = this;
      // 如果在预渲染中使用login，就直接返回debugAlert
      // try {
      //   if (window && (window as any).zzPreRender) {
      //     this.ZZAPP.run('debugAlert', {
      //       title: '预渲染提示',
      //       content: '预渲染中不能调用login，请参考预渲染的接入文档，进行修改',
      //       buttons: ['确定']
      //     }, () => {})
      //   }
      // } catch (error) {

      // }

      var zljOpt = {
        type: 0
      };
      // 上门超人app - 使用转转ppu的参数
      var updoorOpt = {
        needToken2ppu: false
      };
      var forceLogin = false;
      if (_typeof(callback) === 'object') {
        zljOpt = callback.zljOpt || zljOpt;
        forceLogin = callback.forceLogin || forceLogin;
        // 上门超人app，h5页面需要跟转转ppu关联，需要通过token换ppu-2022.11.23
        updoorOpt = callback.updoorOpt || updoorOpt;
        callback = callback.callback;
      }

      // 上门超人app && 需要关联转转ppu，请求联登接口获取ppu种入cookie - 接口byzhujianchao
      if (this["native"].currentPlatform.name == 'zzupdoor' && updoorOpt.needToken2ppu) {
        var cbName = "updoorCallback".concat(guid());
        window[cbName] = function (data) {
          var respCode = data.respCode;
          callback && callback({
            code: respCode,
            res: data
          });
        };
        loadJS("https://app.zhuanzhuan.com/zzopen/passport/federatedlogin?callback=".concat(cbName), function () {
          return window[cbName] = void 0;
        });
        return;
      }
      var successCb = function successCb() {
        var loginInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var token = loginInfo.token;
        if (token.indexOf('UID=') > -1) {
          setCookie('uid', getPPU(token).UID);
          setCookie('PPU', "\"".concat(token, "\""));
        }
        callback && callback(loginInfo);
      };

      // 找靓机的新webveiw
      if (isZLJ) {
        if (forceLogin) {
          this.ZZAPP.zljlogin(zljOpt, successCb);
          return;
        }
        this.ZZAPP.getUserInfo({}, function (res) {
          if (!res.token) {
            _this4.ZZAPP.zljlogin(zljOpt, successCb);
          } else {
            callback && callback(res);
          }
        });
        return;
      }
      // 兼容客户端删cookie bug
      var feCookie = document.cookie;
      this.ZZAPP.login(function (json) {
        if (document.cookie.indexOf('; t=') < 0) {
          document.cookie = feCookie;
        }
        callback(json);
      });
    }
  }, {
    key: "skipToSearchResult",
    value: function skipToSearchResult(obj, callback) {
      // obj.cityId = obj.cityId || "0";
      // obj.sortType = obj.sortType || "0";
      // obj.startPrice = obj.startPrice || -1;
      // obj.endPrice = obj.endPrice || -1;
      // obj.listType = obj.listType || "0";
      // this.ZZAPP.enterSearchResult(obj, callback);

      this.enterUnifiedUrl({
        unifiedUrl: "zhuanzhuan://jump/core/searchResult/jump?" + "cityId=".concat(obj.cityId || '0') + "cateId=".concat(obj.cateId || '0') + "&sortType=".concat(obj.sortType || '0') + "&startPrice=".concat(obj.startPrice || '') + "&endPrice=".concat(obj.endPrice || '') + "&keyword=".concat(encodeURIComponent(obj.keyWord || obj.title || '')) + "&searchType=0"
      });
    }
  }, {
    key: "enlargeImage",
    value: function enlargeImage(obj, callback) {
      if (isZLJ) {
        this.ZZAPP.browsePicture({
          index: obj.selectedIndex,
          list: obj.imgUrls.split('|')
        });
        return;
      }
      this.ZZAPP.enlargeImage(obj, callback);
    }
  }, {
    key: "uploadPhotos",
    value: function uploadPhotos(obj, callback) {
      obj.maxAllowCount = obj.maxAllowCount || '5';
      this.ZZAPP.uploadPhotos(obj, callback);
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo(callback, fun) {
      if (typeof callback !== 'function') {
        callback = callback.success;
      }
      if (isZLJ) {
        if (fun && typeof fun == 'function') {
          fun(this.ZZAPP.zljGetUserInfo({}));
        } else {
          callback(this.ZZAPP.zljGetUserInfo({}));
        }
      } else if (fun && typeof fun == 'function') {
        this.ZZAPP.getUserInfo({}, fun);
      } else {
        this.ZZAPP.getUserInfo({}, callback);
      }
    }
  }, {
    key: "getContextInfo",
    value: function getContextInfo(callback, fun) {
      if (typeof callback !== 'function') {
        callback = callback.success;
      }
      if (isZLJ) {
        if (fun && typeof fun == 'function') {
          fun(this.ZZAPP.zljGetUserInfo({}));
        } else {
          callback(this.ZZAPP.zljGetContextInfo({}));
        }
      } else if (fun && typeof fun == 'function') {
        this.ZZAPP.getContextInfo({}, fun);
      } else {
        this.ZZAPP.getContextInfo({}, callback);
      }
    }
  }, {
    key: "close",
    value: function close(obj, callback) {
      this.ZZAPP.close(obj, callback);
    }
  }, {
    key: "enterChat",
    value: function enterChat(obj) {
      if (obj.useWeb) {
        _get(_getPrototypeOf(ZZAdapter.prototype), "enterChat", this).call(this, obj);
        return;
      }
      this.ZZAPP.enterChat(obj);
    }
  }, {
    key: "chooseAddress",
    value: function chooseAddress() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var addressId = obj.addressId,
        closeTag = obj.closeTag;
      if (isZLJ) {
        var isZljThan9_1_85 = compareVersion(getZZVersion(), '9.1.85') >= 0;
        var params = _objectSpread({
          addressId: addressId || 0,
          success: function success(res) {
            try {
              callback && callback(formartChooseAddressRes(res));
            } catch (error) {
              console.log(error);
            }
          },
          fail: function fail(res) {
            callback && callback(res);
          }
        }, isZljThan9_1_85 ? {
          closeTag: closeTag || '0'
        } : {});
        this.ZZAPP.chooseReceiveAddress(params);
      } else {
        this.ZZAPP.chooseAddress({
          addressId: addressId || 0
        }, callback);
      }
    }
  }, {
    key: "getMarkLocation",
    value: function getMarkLocation(obj, callback) {
      if (isZZ && obj.needOpenNewpage) {
        var _obj$needClose2 = obj.needClose,
          needClose = _obj$needClose2 === void 0 ? '0' : _obj$needClose2,
          _obj$newPageTitle = obj.newPageTitle,
          newPageTitle = _obj$newPageTitle === void 0 ? '转转' : _obj$newPageTitle;
        this.ZZAPP.enterPage({
          targetUrl: getPoiMarkerUrl(obj),
          needClose: needClose,
          newPageTitle: newPageTitle
        }, callback);
      } else {
        this.ZZAPP.enterUnifiedUrl({
          unifiedUrl: '' + "zhuanzhuan://jump/core/routePlan/jump?" + "goodLatitude=".concat(obj.lat) + "&goodLongitude=".concat(obj.lon) + "&goodVillage=".concat(encodeURIComponent(obj.name || '')) + "&goodAddress=".concat(encodeURIComponent(obj.address || ''))
        });
      }
    }
  }, {
    key: "setPageBackAction",
    value: function setPageBackAction(callback) {
      if (isZLJ) {
        if (compareVersion(getCookie('v'), '9.1.10') >= 0) {
          this.ZZAPP.setPageBackAction(function () {
            if (arguments.length <= 0 ? undefined : arguments[0]) {
              return callback.apply(void 0, arguments);
            }
          });
        } else {
          this.ZZAPP.on('backEvent', function () {
            callback && callback();
          });
        }
      } else {
        this.ZZAPP.setPageBackAction(function () {
          if (arguments.length <= 0 ? undefined : arguments[0]) {
            return callback.apply(void 0, arguments);
          }
        });
      }
    }
  }, {
    key: "getQRCodeScan",
    value: function getQRCodeScan(obj, callback) {
      this.ZZAPP.getQRCodeScan(obj, function (res) {
        if (callback) {
          callback({
            code: res.code,
            resultString: res.resultString || '',
            resultStr: res.resultString || '',
            msg: ''
          });
        }
      });
    }
  }, {
    key: "getSystemExtraInfo",
    value: function getSystemExtraInfo(param) {
      var success = param.success || function () {};
      success(this.ZZAPP.getSystemExtraInfo());
    }
  }, {
    key: "enterUnifiedUrl",
    value: function enterUnifiedUrl() {
      var _this$ZZAPP;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var url = args[0].unifiedUrl;
      var cb = args[1] || function () {};
      var encodePath = encodeURIComponent(url);
      if (isHTTPUrl(url) && isZZ) {
        this.skipToUrl({
          targetUrl: url
        }, cb);
        return;
      }
      if (isZZSellerUrl(url)) {
        this.ZZAPP.enterUnifiedUrl({
          unifiedUrl: "zhuanzhuan://jump/core/openZhuanZhuanSeller/jump?url=".concat(encodePath)
        }, cb);
        return;
      }
      if (isHTTPUrl(url) && isZLJ) {
        this.ZZAPP.enterUnifiedUrl({
          unifiedUrl: "zljgo://native_api?type=1&content=".concat(encodePath)
        }, cb);
        return;
      }
      (_this$ZZAPP = this.ZZAPP).enterUnifiedUrl.apply(_this$ZZAPP, args);
    }
  }, {
    key: "onShow",
    value: function onShow() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (checkSdkSupport('10.0.0')) {
        this.ZZAPP.onShow(obj, callback);
        return;
      }
      _get(_getPrototypeOf(ZZAdapter.prototype), "onShow", this).call(this, obj, callback);
    }
  }, {
    key: "onHide",
    value: function onHide() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (checkSdkSupport('10.0.0')) {
        this.ZZAPP.onHide(obj = {}, callback);
        return;
      }
      _get(_getPrototypeOf(ZZAdapter.prototype), "onHide", this).call(this, obj, callback);
    }
  }, {
    key: "registerPageCallback",
    value: function registerPageCallback(callback) {
      var useOrigin;
      var channel;
      if (_typeof(callback) === 'object') {
        useOrigin = callback.useOrigin;
        callback = callback.callback;
        // 是否支持触发多个cb 而非直接覆盖旧cb
        channel = callback.channel;
      }
      if (useOrigin === true) {
        this.ZZAPP.registerPageCallback(function (res) {
          callback && callback(res);
        }, channel);
      } else {
        this.ZZAPP.registerPageCallback(function (res) {
          if (res && res.code === '0' && res.pageState === '1') {
            callback && callback(res);
          }
        }, channel);
      }
    }
  }, {
    key: "requestLocation",
    value: function requestLocation() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var wihteList = ['act.zhuanzhuan.com/platform/zz-platform-pages/zzNearbyPerson', 'm.zhuanzhuan.com/u/bmmain', 'm.zhuanzhuan.com/u/offline_store_user', 'm.zhuanzhuan.com/platform/newCycle', 'm.zhuanzhuan.com/common/sdktest', 'm2.zhuanzhuan.com/u/bmmain', 'm2.zhuanzhuan.com/u/offline_store_user', 'm2.zhuanzhuan.com/platform/newCycle', 'm2.zhuanzhuan.com/common/sdktest', 'm.zhuanzhuan.com/u/bm-consign', 'm2.zhuanzhuan.com/u/bm-consign', 'm2.zhuanzhuan.com/u/b2c_one_page_bizs', 'm.zhuanzhuan.com/u/b2c_one_page_bizs'];
      // 判断当前页面的url是否在白名单中
      var currentUrl = window.location.href;
      var isInWhiteList = wihteList.some(function (item) {
        return currentUrl.indexOf(item) > -1;
      });
      // skipWhiteList 为true时，不判断白名单, fe组件专用
      var skipWhiteList = obj.skipWhiteList;
      if (!skipWhiteList && !isInWhiteList) {
        callback && callback({
          code: '-9',
          msg: '当前业务未开通实时定位权限，请联系支撑组添加',
          debugMsg: '当前业务未开通实时定位权限，请联系支撑组添加'
        });
        return;
      }
      obj.adapterWhiteList = 1;
      try {
        this.ZZAPP.requestLocation(obj, callback);
      } catch (e) {
        callback && callback({
          code: '-1',
          msg: '无知错误',
          debugMsg: "\u65E0\u77E5\u9519\u8BEF".concat(e)
        });
      }
    }
  }, {
    key: "setPpuAndIsLogin",
    value: function setPpuAndIsLogin(_ref2) {
      var callback = _ref2.callback;
      var that = this;
      this.ZZAPP.getCookie(function (res) {
        var code = res.code,
          cookie = res.cookie;
        if (code == 0) {
          var ppu = getCookie('PPU', cookie);
          var safe_ppu = getCookie('Safe-PPU', cookie);
          var uid = getCookie('uid', cookie);
          console.log('端内，isLoginAsync第一次获取ppu:', ppu);
          console.log('端内，isLoginAsync第一次获取safe_ppu:', safe_ppu);
          console.log('端内，isLoginAsync第一次获取uid:', uid);
          // 处理获取cookie不到的情况，在安卓上会获取不到。因为getcookie在sdk里面已经完成了注入，其实不用获取也会更新的
          if (!ppu) {
            // 兼容一些获取不到ppu的情况
            ppu = getStrCookie('PPU', cookie);
            console.log('端内，isLoginAsync第二次获取ppu:', ppu);
          }
          if (!safe_ppu) {
            // 兼容一些获取不到ppu的情况
            safe_ppu = getStrCookie('Safe-PPU', cookie);
            console.log('端内，isLoginAsync第二次获取safe_ppu:', safe_ppu);
          }
          if (!uid) {
            // 兼容一些获取不到ppu的情况
            uid = getStrCookie('uid', cookie);
            console.log('端内，isLoginAsync第二次获取uid:', uid);
          }
          if (ppu && ppu !== '""' && ppu !== 'null' && ppu !== 'undefined' && ppu !== '0' && ppu !== 'false') {
            setCookie('PPU', ppu);
            console.log('端内，isLoginAsync设置ppu', ppu);
          }
          if (safe_ppu && safe_ppu !== '""' && safe_ppu !== 'null' && safe_ppu !== 'undefined' && safe_ppu !== '0' && safe_ppu !== 'false') {
            setCookie('Safe-PPU', safe_ppu);
            console.log('端内，isLoginAsync设置safe_ppu', safe_ppu);
          }
          if (uid && uid !== '""' && uid !== 'null' && uid !== 'undefined' && uid !== '0' && uid !== 'false') {
            setCookie('uid', uid);
            console.log('端内，isLoginAsync设置uid', uid);
          }
          var isLogin = that.isLogin();
          console.log('端内，isLoginAsync开始判断是否登录, 并执行回调', isLogin);
          callback(isLogin);
        }
      });
    }
  }, {
    key: "setStoreItem",
    value: function setStoreItem(group, name, value, expire, callback) {
      if (checkSdkSupport('10.13.0')) {
        // If the value is an object, stringify it.
        if (_typeof(value) === 'object') {
          value = JSON.stringify(value);
        }
        // If there is an expiration date, calculate it.
        if (typeof expire === 'number') {
          expire = Date.now() + expire * 1000 * 60 * 60 * 24;
        }
        // 循环打印this.ZZAPP的key
        for (var key in Object.keys(this.ZZAPP)) {
          console.log('key', Object.keys(this.ZZAPP)[key]);
        }
        // Save the value in local storage, with the expiration date if there is one.
        this.ZZAPP.setNativeStorageItem({
          "key": "".concat(group, "_").concat(name),
          "value": JSON.stringify({
            value: value,
            expire: expire
          })
        }, function (res) {
          if (res.code !== '0') {
            callback && callback(false);
          } else {
            callback && callback(true);
          }
        });
      } else {
        _get(_getPrototypeOf(ZZAdapter.prototype), "setStoreItem", this).call(this, group, name, value, expire, callback);
      }
    }
  }, {
    key: "getStoreItem",
    value: function getStoreItem(group, name, callback) {
      var _this5 = this;
      if (checkSdkSupport('10.13.0')) {
        this.ZZAPP.getNativeStorageItem({
          "key": "".concat(group, "_").concat(name)
        }, function (res) {
          if (res.code !== '0') {
            callback && callback(null);
          }
          var str = res.value;
          // If there is no value, return null.
          if (!str) {
            callback && callback(null);
          }
          try {
            var resObj = JSON.parse(str);
            var _value = resObj.value,
              _expire = resObj.expire;
            if (_expire && _expire < Date.now()) {
              _this5.removeStoreItem(group, name, function () {
                callback && callback(null);
              });
            } else {
              callback && callback(_value);
            }
          } catch (e) {
            callback && callback(null);
          }
        });
      } else {
        _get(_getPrototypeOf(ZZAdapter.prototype), "getStoreItem", this).call(this, group, name, callback);
      }
    }
  }, {
    key: "removeStoreItem",
    value: function removeStoreItem(group, name, callback) {
      if (checkSdkSupport('10.13.0')) {
        this.ZZAPP.removeNativeStorageItem({
          "key": "".concat(group, "_").concat(name)
        }, function (res) {
          if (res.code !== '0') {
            callback && callback(false);
          } else {
            callback && callback(true);
          }
        });
      } else {
        _get(_getPrototypeOf(ZZAdapter.prototype), "removeStoreItem", this).call(this, group, name, callback);
      }
    }
  }, {
    key: "copyTextToClipBoard",
    value: function copyTextToClipBoard(clipText, callback) {
      var _this6 = this;
      this.ZZAPP.hasSupportFeature({
        method: 'copyTextToClipBoard'
      }, function (res) {
        if (res.code === '1') {
          _this6.ZZAPP.run('copyTextToClipBoard', {
            clipText: clipText
          }, function (res) {
            if (res.code === '0') {
              callback && callback({
                code: '0',
                msg: '复制成功'
              });
            } else {
              callback && callback({
                code: '-1',
                msg: '复制失败'
              });
            }
          });
        } else {
          if (isZLJ) {
            _this6.ZZAPP.run('pasteText', {
              content: clipText
            }, function (res) {
              if (res.code === '0') {
                callback && callback({
                  code: '0',
                  msg: '复制成功'
                });
              } else {
                callback && callback({
                  code: '-1',
                  msg: '复制失败'
                });
              }
            });
          } else {
            // super
            _get(_getPrototypeOf(ZZAdapter.prototype), "copyTextToClipBoard", _this6).call(_this6, clipText, callback);
          }
        }
      });
    }
  }]);
  return ZZAdapter;
}(BaseAdapter), _class2.pluginName = 'ZZAdapter', _class2.platform = [{
  rule: /58ZhuanZhuan/i,
  name: 'zz',
  scheme: 'zhuanzhuan://'
}, {
  // 找靓机新webview
  rule: function rule() {
    return /zhaoliangji-v2/i.test(navigator.userAgent) && (getUrlParams().needNewWebview == '1' || getUrlParams().needNewWebView == '1' || compareVersion(getCookie('v'), '9.1.10') >= 0);
  },
  name: 'zlj',
  isNewWebview: true
},
// 转转门店
{
  rule: /zzstore|offlinestorecomplex/i,
  name: 'zzstore'
},
// 上门超人
{
  rule: /zzupdoor/i,
  name: 'zzupdoor'
},
// 质检app
{
  rule: /QcBrain/i,
  name: 'QcBrain'
},
// 质检工具 app
{
  rule: /QcTools/i,
  name: 'QcTools'
},
// 仓储wms pda
{
  rule: /wmspda/i,
  name: 'wmspda'
},
// 质检监察系统app
{
  rule: /qcqualityinspect/i,
  name: 'qcqualityinspect'
},
// 飞检App
{
  rule: /QualityInspect/i,
  name: 'QualityInspect'
},
//上门小哥App
{
  rule: /zzluxury/i,
  name: 'zzluxury'
},
//zzqcidentity
{
  rule: /zzqcidentity/i,
  name: 'zzqcidentity'
}], _class2), (_applyDecoratedDescriptor(_class.prototype, "login", [beforeLogin], Object.getOwnPropertyDescriptor(_class.prototype, "login"), _class.prototype)), _class);
export { ZZAdapter as default };